import {
  SbarCommunicationMethod,
  SbarSectionKey,
  SbarStatus
} from "@/types/cppt";

export interface SbarSection {
  key: SbarSectionKey;
  letter: string;
  title: string;
  subtitle: string;
  color: string;
  hex: string;
}

export interface SbarStatusBadge {
  label: string;
  color: string;
  textColor: string;
}

export const SBAR_SECTIONS: SbarSection[] = [
  {
    key: "situation",
    letter: "S",
    title: "Situation",
    subtitle: "Kondisi / situasi kegawatan pasien saat ini",
    color: "red darken-1",
    hex: "#e53935"
  },
  {
    key: "background",
    letter: "B",
    title: "Background",
    subtitle: "Riwayat dan informasi klinis relevan",
    color: "blue darken-1",
    hex: "#1e88e5"
  },
  {
    key: "assessment",
    letter: "A",
    title: "Assessment",
    subtitle: "Hasil asesmen / dugaan masalah klinis pasien",
    color: "green darken-1",
    hex: "#43a047"
  },
  {
    key: "recommendation",
    letter: "R",
    title: "Recommendation",
    subtitle: "Rekomendasi / permintaan arahan terapi kepada DPJP",
    color: "purple darken-1",
    hex: "#8e24aa"
  }
];

export const SBAR_COMMUNICATION_LABEL: Record<
  SbarCommunicationMethod,
  string
> = {
  telepon: "Telepon",
  tatap_muka: "Tatap Muka",
  video_call: "Video Call",
  pesan_tertulis: "Pesan Tertulis (WA/SMS)"
};

export const SBAR_COMMUNICATION_OPTIONS: Array<{
  value: SbarCommunicationMethod;
  text: string;
}> = (Object.keys(SBAR_COMMUNICATION_LABEL) as SbarCommunicationMethod[]).map(
  value => ({ value, text: SBAR_COMMUNICATION_LABEL[value] })
);

export const SBAR_VERBAL_METHODS: SbarCommunicationMethod[] = [
  "telepon",
  "tatap_muka",
  "video_call"
];

export const SBAR_TBAK_STATEMENT =
  "Instruksi telah dibacakan ulang secara detail kepada DPJP dan dikonfirmasi benar oleh DPJP";

export const SBAR_VERIFY_STATEMENT =
  "Dengan memverifikasi, Anda menyatakan respons dan instruksi yang dicatat pelapor sesuai dengan yang Anda sampaikan.";

export const SBAR_VERIFY_PLACEHOLDER =
  "Silakan isi kolom ini bila ada catatan terkait isi Readback Pemberi Laporan";

export const SBAR_STATUS_BADGE: Record<SbarStatus, SbarStatusBadge | null> = {
  draft: {
    label: "Draft",
    color: "orange lighten-4",
    textColor: "orange darken-4"
  },
  menunggu_verifikasi: {
    label: "Menunggu Verif DPJP",
    color: "blue lighten-5",
    textColor: "blue darken-2"
  },
  terverifikasi: null
};
